import {
  Box,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MaterialsTable from "./MaterialsTable";

import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Chip } from "@mui/material";
import { drawingCols } from "./utils";
import CopyUrlButton from "../../../../../../../../../../components/btns/CopyLinkBtn";
import PdfModal from "../../../../../../../../../../components/PdfViewer/PdfModal";
import { useBOMDashboardContext } from "../../../../BOMDashboard.context";

export default function Row({
  row,
  index,
  removeSelectedDrawing,
  selectionMaterials,
  setSelectionMaterials,
}) {
  const [open, setOpen] = React.useState(true);
  const [docOpen, setDocOpen] = React.useState(false);

  // ---- TEST ONLY: hardcode a PDF URL for the first row to test the modal.
  // Leave TEST_DOC_URL empty ("") to use the real drawing.document.docLink.
  const TEST_DOC_URL =
    "https://chinookdt189.sharepoint.com/:b:/s/SkidPackage/IQAZzPjpVfhiToz3ruFenIxeASsMJWVy7rvYsBDcbCR-n7A?e=c0eWzH"; // <-- paste your test PDF URL here
  const docLink =
    index === 0 && TEST_DOC_URL ? TEST_DOC_URL : row?.document?.docLink;
  // ---- END TEST ONLY

  const onRemove = () => {
    removeSelectedDrawing(row.id);
  };
  const { plant } = useBOMDashboardContext();
  const link =
    `/plant/${plant?.id}/mcs#mcs-tab=Drawing%20BOM&mcs-tab=BOM%20Dashboard&drawing-id=` +
    row?.id;
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell sx={{ width: 300 }}>
          <IconButton size="small" sx={{ mr: 2 }} onClick={onRemove}>
            <RemoveCircleOutlineIcon color="error" />
          </IconButton>

          <IconButton
            aria-label="expand row"
            size="small"
            sx={{ mr: 1 }}
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>

          <Box component="span">
            {selectionMaterials[row.id]?.length ? (
              <Chip
                label={
                  selectionMaterials[row.id]?.length + " materials selected"
                }
                color="primary"
              />
            ) : (
              ""
            )}
          </Box>
        </TableCell>

        {drawingCols.map((col) => {
          return (
            <TableCell
              key={col.label}
              sx={{ color: col.key === "id" && "#888" }}
            >
              {col.key === "id" && "ID: "}{" "}
              {col.key === "revision" ? "" : row[col.key]}{" "}
              {col.key === "id" && (
                <CopyUrlButton subLink={link} sx={{ ml: 1 }} />
              )}
              {col.key === "revision" && (
                <Chip
                  color="primary"
                  size="small"
                  label={"Rev-(" + row[col.key] + ")"}
                />
              )}
            </TableCell>
          );
        })}

        <TableCell sx={{ width: 80, textAlign: "center" }}>
          <IconButton
            aria-label="view document"
            size="small"
            onClick={() => setDocOpen(true)}
            disabled={!docLink}
          >
            <PictureAsPdfIcon color={docLink ? "primary" : "disabled"} />
          </IconButton>
          <PdfModal
            open={docOpen}
            onClose={() => setDocOpen(false)}
            src={docLink}
            useProxy={/sharepoint\.com|graph\.microsoft\.com/i.test(
              docLink || "",
            )}
            title={"Document - " + (row?.dwgNumber || row?.title || "Drawing")}
          />
        </TableCell>
      </TableRow>
      <TableRow
        sx={{ backgroundColor: "hsla(250, 86%, 97%, 1)", width: "100%" }}
      >
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom component="div">
                Materials
              </Typography>
              <MaterialsTable drawing={row} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
